import { cn } from 'noddi-ui-common';
import { reduceDurationParts, type DurationTranslations, type DurationUnit } from 'noddi-util';

type Props = {
  value: number;
  units: readonly DurationUnit[];
  translations: DurationTranslations;
  placeholder?: string;
};

const UNIT_LABELS: Record<
  DurationUnit,
  keyof Pick<DurationTranslations, 'unitDayShort' | 'unitHourShort' | 'unitMinuteShort' | 'unitSecondShort'>
> = {
  d: 'unitDayShort',
  h: 'unitHourShort',
  m: 'unitMinuteShort',
  s: 'unitSecondShort'
};

export const DurationReadout = ({ value, units, translations, placeholder }: Props) => {
  if (!value) {
    return <span className='text-muted-foreground'>{placeholder}</span>;
  }

  const parts = reduceDurationParts(value, units);
  const tokens = units.map((u) => ({ unit: u, value: parts[u] })).filter((t) => t.value > 0);

  if (tokens.length === 0) {
    return <span className='text-muted-foreground'>0</span>;
  }

  return (
    <span className={cn('inline-flex items-baseline gap-1.5 tabular-nums')}>
      {tokens.map((t) => (
        <span key={t.unit} className='inline-flex items-baseline gap-1'>
          <span className='font-semibold'>{t.value}</span>
          <span className='text-sm font-medium text-muted-foreground'>{translations[UNIT_LABELS[t.unit]]}</span>
        </span>
      ))}
    </span>
  );
};
